import React from "react"; 
import AdminTopbar from "../../component/AdminTopbar";
import { Link, ChevronRight } from "react-feather";
const AdminFileManager = () => {
  return (


    <div className="App" style={{ display: "flex" }}>

<div className="" style={{ flexGrow: 1, padding: "0px" }}>
<AdminTopbar/>

    <div className="file-manager">
      {/* Sidebar */}
      <aside className="sidebarFile">
        <h3 className="myflies">MY FILES</h3>
        <ul className="fileul p-0">
          <li className="filename"><ChevronRight size={13}/>&nbsp;📁 Documents</li>
          <li className="filename"><ChevronRight size={13}/>&nbsp;📁 Applications</li>
          <li className="filename"><ChevronRight size={13}/>&nbsp;📁 Archives</li>
        </ul>
        <div className="storage-info">
          <p>Trash</p>
          <p>620GB of 1TB <span>Upgrade</span></p>
          <div className="storage-bar">
            <div className="filled"></div>
          </div>
        </div>
      </aside>
      
      {/* Main Content */}
      <main className="contentfile">

        <div className=" text-start">
                            <div >
                            <h2 className="chart-title text-start">
                            Home
                          </h2> 
                            </div>

                            <div className="filter-tabs d-flex ">
            <button  className="new-project-btn me-2">Recent</button>
            <button className="new-project-btn">Pinned</button>
          </div> 
                        </div>
 
        
        {/* File Cards */}
        <div className="file-cards">
          <div className="card blue">Dribbble Shots <span>22 files</span></div>
          <div className="card orange">Design <span>135 files</span></div>
          <div className="card cyan">My Portfolio <span>14 files</span></div>
          <div className="card pink">Behance Files <span>18 files</span></div>
        </div>
        
        {/* Folder Table */}
        <table className="folder-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Last Edit</th>
              <th>Size</th>
              <th>Members</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>📂 Web Applications</td>
              <td>21 Nov 2023</td>
              <td>48.26 GB</td>
              <td>👤 GU TV DM</td>
            </tr>
            <tr>
              <td>📂 Media</td>
              <td>23 Dec 2023</td>
              <td>16.34 GB</td>
              <td>👤 3 members</td>
            </tr>
            <tr>
              <td>📂 Designs</td>
              <td>12 Dec 2023</td>
              <td>2.69 GB</td>
              <td>👤 BN</td>
            </tr>
          </tbody>
        </table>
        
        {/* Tags Section */}
        <div className="tags">
          <div className="tag blue">#image (654 Files)</div>
          <div className="tag green">#video (135 Files)</div>
          <div className="tag orange">#documents (5477 Files)</div>
        </div>
      </main>
    </div>

    </div>
    </div>
  );
};

export default AdminFileManager;